export default __webpack_public_path__ + "87f3268130960701e1f90d66048101dc.png";